export default __webpack_public_path__ + "static/media/BBB-white.8ac95883.svg";